import { Flex } from '@chakra-ui/react'
import React from 'react'
import AboutUs from './AboutUs'
import OurWork from './Work'
import OurServices from './OurServices'
import { ReactComponent as Payment } from '../../assets/svg/payment.svg'
import { ReactComponent as Professional } from '../../assets/svg/professional.svg'
import { ReactComponent as Roller } from '../../assets/svg/roller.svg'
import { ReactComponent as Factory } from '../../assets/svg/factory.svg'
import { ReactComponent as Document } from '../../assets/svg/documentation.svg'
import { ReactComponent as Control } from '../../assets/svg/camera.svg'
import { ReactComponent as Delivery } from '../../assets/svg/delivery.svg'
import { ReactComponent as Tools } from '../../assets/svg/tools.svg'
import { ReactComponent as Bulldozer } from '../../assets/svg/bulldozer.svg'
import Usluga1 from '../../assets/img/blago.webp'
import Usluga2 from '../../assets/img/plitka.webp'
import Usluga3 from '../../assets/img/landshaft.webp'
import Usluga4 from '../../assets/img/asfalt.webp'
import Usluga5 from '../../assets/img/zemlya.webp'
import Usluga6 from '../../assets/img/montage.webp'
import Usluga7 from '../../assets/img/grunt.webp'
import Usluga8 from '../../assets/img/musr.webp'
import Usluga9 from '../../assets/img/krovlya.webp'
import Equipment from './Equipment'
import Content from './Content'
import Collectiv from './Collectiv'
import AdvantagesMobile from './AdvantagesMobile'



const Home = () => {

  const Advantages = [
    { id: 1, icon: <Payment />, title: "БЕЗ ПРЕДОПЛАТЫ", about: "Вы будете оплачивать лишь принятые вами работы, качество которых вас устраивает", display:"flex" },
    { id: 2, icon: <Professional />, title: "РАБОТАЮТ ПРОФЕССИОНАЛЫ", about: "Команда профессиональных строителей, которые прошли аттестацию", display:"flex" },
    { id: 3, icon: <Document />, title: "ДОКУМЕНТАЦИЯ", about: "Полный пакет проектной документации, который вы получаете бесплатно", display:"flex" },
    { id: 4, icon: <Control />, title: "КОНТРОЛЬ КАЧЕСТВА", about: "Можно отслеживать ход проведения работ в режиме реального времени", display:"flex" },
    { id: 5, icon: <Roller />, title: "КАЧЕСТВЕННЫЕ МАТЕРИАЛЫ", about: "Мы сами купим и доставим самые высококачественные материалы", display:"flex" },
    { id: 6, icon: <Factory />, title: "ГАРАНТИЯ", about: "Мы проявляем индивидуальный подход и заботу для каждого нашего клиента", display:"flex" },
    { id: 7, icon: <Bulldozer />, title: "СПЕЦТЕХНИКА", about: "Мы имеем огромный парк строительной и дорожной техники.", display:"none" },
    { id: 8, icon: <Delivery />, title: "БЫСТРЫЙ ВЫЕЗД", about: "Быстро приближаемся к Томску и соседним городам.", display:"flex" },
    { id: 9, icon: <Tools />, title: "БЕСПЛАТНЫЕ ЗАМЕРЫ", about: "Измеряем новыми приборами и точно.", display:"flex" },
  ]


 const Services = [
  { id: 1, image: Usluga1, title: "Благоустройство территорий", alt: "Благоустройство частной территории: укладка дорожек, газона и оформление участка" },
  { id: 2, image: Usluga2, title: "Укладка плитки и бордюра", alt: "Укладка тротуарной плитки и установка дорожных бордюров на участке" },
  { id: 3, image: Usluga3, title: "Ландшафтный дизайн", alt: "Ландшафтный дизайн участка с озеленением и планировкой территории" },
  { id: 4, image: Usluga4, title: "Асфальтирование территорий", alt: "Асфальтирование дворов и дорог с применением дорожной техники" },
  { id: 5, image: Usluga5, title: "Земляные работы", alt: "Земляные работы: выемка, планировка и подготовка грунта под строительство" },
  { id: 6, image: Usluga6, title: "Строительно монтажные работы", alt: "Строительно-монтажные работы: возведение и монтаж конструкций на объекте" },
  { id: 7, image: Usluga7, title: "Вывоз грунта", alt: "Вывоз грунта с участка самосвалами после земляных работ" },
  { id: 8, image: Usluga8, title: "Вывоз строительного мусора", alt: "Вывоз строительного мусора с площадки после ремонта или стройки" },
  { id: 9, image: Usluga9, title: "Мягкой Кровли", alt: "Монтаж мягкой кровли и гидроизоляция крыш частных домов" },
]

  return (
    <Flex id='home' w={"full"} bg={"colors.brand.200"} justifyContent={"center"} flexDirection={"column"} fontFamily={"Montserrat"}>
     <Content />
      <AboutUs  advantages={Advantages} />
       <OurWork />
       <AdvantagesMobile advantages={Advantages} />
      <Equipment />
      <OurServices services={Services} />
      <Collectiv />
    </Flex>
  )
}

export default Home